
export const Inputs = [
    [
        
        {
            type: "email",
            name: "email",
            title: { ar: "", en: "" },
            label: { ar: "من فضلك ادخل البريد الالكتروني او رقم الهاتف لاعادة تعيين كلمة المرور", 
                en: "Please, send your email or phone number to reset the password" },
            placeholder: "NewConcept@gmail.com",
        },
        {
            type: "select",
            name: "type",
            label: { ar: "اختر النوع", en: "Choose type" },
            title: { ar: "", en: "" },
            optionTitle: { ar: "النوع", en: "Type" },
            options: [
                { value: "TEACHER", title: { ar: "مدرس", en: "Teacher" } },
                { value: "ASSISTANT", title: { ar: "مساعد", en: "Assistant" } },
                { value: "STUDENT", title: { ar: "طالب", en: "Student" } },
                { value: "PARENT", title: { ar: "ولي امر", en: "Parent" } },
            ],
           
        },
    ]

];